import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import Grid from '@material-ui/core/Grid';
import { ENVIRONMENTVARIABLE } from 'src/constants/appConstants';

export const HeaderContainer = styled(Grid)`
    width: 98%;
    display: flex;
    font-size: 24px;
    font-family: AvenirNextWorld Demi;
    top: 253px;
    color: #140f4b;
    left: 277px;
    width: 1000px;
    // height: 48px;
    padding: 15px 20px;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 6px #00000029;
    border: 1px solid #dcdcdc;
    border-radius: 6px;
    margin-top: 12px;
    margin-bottom: 10px;
    opacity: 1;
    position: sticky;
    top: 0;
    ${media.mobileDevice`
     display:none !important;
        `}
`;
export const ContactInfo = styled.span`
    font-family: AvenirNextWorld Demi;
    color: #140f4b;
    width: 40px;
    display: inline-block;
    text-align: right;
    padding-right: 5px;
`;
export const FavouriteIcon = styled.img.attrs((props) => ({
    src: props.mobilePath,
}))`
    top: 275px;
    left: 1052px;
    width: 14px;
    height: 13px;
    background: #f4af3d 0% 0% no-repeat padding-box;
    opacity: 1;

    ${media.mobileDevice`
top: 318px;
left: 340px;
width: 14px;
height: 13px;
background: #F4AF3D 0% 0% no-repeat padding-box;
opacity: 1;
`}
`;
export const FavouriteIconDesktopContainer = styled.div`
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 2px #00000029;
    border: 1px solid #ebebeb;
    border-radius: 6px;
    opacity: 1;
    width: 24px;
    height: 24px;
    display: flex;
    text-align: center;
    align-items: center;
    margin-left: 24px;
    justify-content: center;
    margin-right: ${({ marginRight }) => marginRight};

    ${media.mobileDevice`
        display:none;
    `};
`;
export const FavoriteIconMobileContainer = styled.div`
    display: none;
    ${media.mobileDevice`
        background: #ffffff 0% 0% no-repeat padding-box;
        box-shadow: 0px 0px 2px #00000029;
        border: 1px solid #ebebeb;
        border-radius: 6px;
        opacity: 1;
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: ${({ marginRight }) => marginRight};
    `};
`;

export const FavoriteIconContainer = styled(Grid)`
    top: 310px;
    left: 332px;
    width: 30px;
    height: 30px;
    background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 2px #00000029;
    border: 1px solid #ebebeb;
    border-radius: 6px;
    opacity: 1;
    margin-right: ${({ marginRight }) => marginRight};
    ${media.mobileDevice`
         
         order:2;
         float: right;
         position: relative;
         right: 7px;
        bottom: 100px;
    `};
`;

export const BodyGridContainer = styled(Grid)`
    width: 98%;
    top: 253px;
    left: 277px;
    width: 810px;
    padding: 15px 20px;
    // height: 80px;
    // padding-top: 14px;
    // padding-left: 14px;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 6px #00000029;
    border: 1px solid #dcdcdc;
    border-radius: 6px;
    margin-top: 3px;
    margin-bottom: 10px;
    opacity: 1;
    display: flex;
    font-size: 24px;
    ${media.mobileDevice`    
    width: 358px;
    // height: 140px;
    // padding-top: 9px;
    // padding-left: 20px;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 6px #00000029;
    border: 1px solid #dcdcdc;
    border-radius: 6px;
    margin-top: 10px;
    margin-bottom: 10px;
    opacity: 1;
    `}
`;

export const SpecialityGrid = styled(Grid)`
    top: 266px;
    left: 491px;
    width: 185px;
    text-align: left;
    font-size: 14px;
    font-family: 'AvenirNextWorld Regular';
    letter-spacing: -0.11px;
    color: #000000;
    opacity: 1;
    ${media.mobileDevice`    
padding-left: 1px;
`}
`;

export const EmailPhoneGrid = styled(Grid)`
    ${media.mobileDevice`    
        padding-left: 1px;
        display: contents;
    `};
`;
export const EmailContainer = styled(Grid)`
    top: 266px;
    left: 869px;
    // height: 21px;
    // margin-left: 18px;
    text-align: left;
    font-size: 12px;
    font-family: 'AvenirNextWorld Regular';
    letter-spacing: -0.1px;
    color: #140f4b;
    opacity: 1;
    word-break: break-all;
    ${media.mobileDevice`  
        text-align: left;
        margin-left: 0px;
        width: 100%;
    `}
`;

export const PhoneContainer = styled(Grid)`
    top: 266px;
    left: 869px;
    // height: 21px;
    font-family: 'AvenirNextWorld Regular';
    text-align: left;
    padding-right: 12px;
    font-size: 12px;
    letter-spacing: 0.05px;
    color: #140f4b;
    opacity: 1;
    text-transform: ${(props) => props.textTransform};
    ${media.mobileDevice`  
        padding-right: 0px;
        width: 100%;
    `}
`;

export const HeaderTextContainer = styled(Grid)`
    // padding-right: 10px;
    // padding-bottom: 20px;
    color: #3c3c3c;
    opacity: 0.7;
    font-size: 13px;
    width: 89px;
    font-family: AvenirNextWorld Demi;
    text-align: left;

    letter-spacing: 0px;
`;

export const HeaderTextContainer1 = styled(Grid)`
    // padding-right: 10px;
    // padding-bottom: 20px;
    color: #3c3c3c;
    opacity: 0.7;
    font-size: 13px;
    width: 89px;
    font-family: AvenirNextWorld Demi;
    text-align: left;

    letter-spacing: 0px;
`;
export const BodyTextContainer = styled(Grid)`
    top: 266px;
    left: 293px;
    width: 182px;
    // height: 24px;
    font-family: 'AvenirNextWorld Regular';
    text-align: left;
    font-size: 14px;

    letter-spacing: -0.11px;
    color: #1010eb;
    opacity: 1;
    ${media.mobileDevice` 
    display: flex;
    justify-content: space-between;
    `}
`;

export const CityGrid = styled(Grid)`
    top: 266px;
    left: 692px;
    width: 106px;
    height: 21px;
    text-align: left;
    font-family: 'AvenirNextWorld Regular';
    color: #726f93;
    font-size: 12px;
    ${media.mobileDevice` 
    text-align: start;
`};
`;

export const OrderDetailTabBodyContainer = styled.div`
    flex-grow: 1;
    overflow-y: scroll;
    margin-top: 5px;
    box-sizing: border-box;
    position: relative;
    &::-webkit-scrollbar {
        display: block;
        width: 5px;
    }

    &::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 10px;
        height: 12rem;
    }
    &::-webkit-scrollbar-thumb:hover {
        background: #555;
    }

    ${media.mobileDevice`
        &::-webkit-scrollbar {
            display: none;
        }
        padding-bottom: 175px;
        padding-right: 0;
        margin-top: -5px;
    `}
`;
export const DesktopView = styled.div`
    display: block;
`;

export const AccountPaginationWrapper = styled.div`
    ${media.mobileDevice`
    position: fixed;
    width: 96%;
    bottom: 0;
    margin: 0 auto;
    `}
`;

export const MobileView = styled.div`
    display: none;
    ${media.mobileDevice`
        display: block;
        background-color: #FFFFFF;
        box-shadow: 0px -3px 6px #00000014;
        margin-left: -16px;
        &.mobile-pagination-wrapper #paginationInfo{
            font-size: 12px !important;
        }
    `}
`;

export const DesktopViewPagination = styled.div`
    display: block;
    @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
        width: 100%;
    }
    ${media.mobileDevice`
        display: none;
    `}
`;
export const PaginationContainerMobile = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0px;
    width: 100%;
    ${media.mobileDevice`
        flex-direction:column;
        padding-top: 10px;
        justify-content: space-between;
        padding-bottom:${({ padding }) =>
            ENVIRONMENTVARIABLE
                ? `max(${
                      padding ? padding : '1.125rem'
                  }, calc(4*env(safe-area-inset-bottom)))`
                : padding
                ? padding
                : '1.125rem'} 
    `}
`;
export const PaginationContainer = styled.div`
    height: 48px;
    box-shadow: none;
    border-radius: 4px 4px 0px 0px;
    opacity: 1;

    ${media.smalDevice`                    
        height: auto;
        box-shadow: none;
        border-radius: none;    
    `}
    ${media.mediumDevice`    
        height: auto;
        box-shadow: none;
        border-radius: none;    
    `}
    ${media.mobileDevice`
    flex-direction:column;
    margin: 10px 0px 0px 0px;
    box-shadow: none;
    border-radius: none;        
`}
`;

export const FavouriteIconMobile = styled.img.attrs((props) => ({
    src: props.mobilePath,
}))`
    width: 24px;
    height: 24px;
    display: block;
    cursor: pointer;
`;

export const StyledPhoneFax = styled.div`
    padding-top: ${(props) => props.paddingTop};
    ${media.mobileDevice`
        padding-top: 0px;
    `}
`;
